import { useIsIcebergEnabled } from "src/hooks/useIsIcebergEnabled";
import { useIsIcebergMetricsEnabled } from "src/hooks/useIsIcebergMetricsEnabled";
import { useWorkspaceContext } from "src/router/routerContextHooks";

// Workspaces that opt into routing /metrics/api/v1/decision_summary to Iceberg
// via the enable_dhv2_metrics flag. Everywhere else, decision_summary follows
// the general read_iceberg signal so pre-Iceberg decisions stay visible for
// workspaces that write to both stores but still read from Aurora.
const ICEBERG_METRICS_DECISION_SUMMARY_WORKSPACE_IDS = new Set<string>([
  // Pleo FRAML
  "5f54fd0d-7940-4348-87ac-4884b1e250ba",
]);

/**
 * Hook to determine if Iceberg should be used for the decision_summary endpoint.
 *
 * Unlike the other metrics endpoints, decision_summary returns no results for
 * pre-Iceberg decisions when routed to Iceberg on workspaces with history mode
 * `write_both_read_aurora`. So by default we fall back to the general
 * `useIsIcebergEnabled()` signal, and only honor `enable_dhv2_metrics` for the
 * small allowlist of workspaces that explicitly want metrics-style routing.
 */
export const useIsIcebergDecisionSummaryEnabled = (): boolean => {
  const { workspace } = useWorkspaceContext();
  const isIcebergMetricsEnabled = useIsIcebergMetricsEnabled();
  const isIcebergEnabled = useIsIcebergEnabled();

  if (ICEBERG_METRICS_DECISION_SUMMARY_WORKSPACE_IDS.has(workspace.id)) {
    return isIcebergMetricsEnabled;
  }
  return isIcebergEnabled;
};
